export const ALERT_TIMEOUT = 3000;
export const INPUT_ERROR_TIMEOUT = 3000;